<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'arrow', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const isDimensionValid = computed(() => {
	if (isCutout) {
		return store.getters.isShapeValid(isCutout) && store.getters.isCutoutGroupValid;
	}

	return store.getters.isShapeValid() && store.getters.isGroupValid;
});

const stemLength = computed({
	get: () => dimensions.value.stem_length,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "stem_length",
			value: value,
		});
	},
});

const stemWidth = computed({
	get: () => dimensions.value.stem_width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "stem_width",
			value: value,
		});
	},
});

const headLength = computed({
	get: () => dimensions.value.head_length,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "head_length",
			value: value,
		});
	},
});

const headWidth = computed({
	get: () => dimensions.value.head_width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "head_width",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="arrow-stem_length"
			:id="`${prefix}measurements-arrow-stem_length`"
			:name="`${prefix}measurements[dimensions][stem_length]`"
			unit="cm"
			:label="dimensionLabel('stem_width', 'arrow')"
			:invalid="!isDimensionValid(`${prefix}arrow-stem_length`)"
			:onBlur="() => addSizeToDataLayer('stem_length', +stemLength, 'arrow')"
			v-model="stemLength"
		/>

		<dimension-input
			inputRef="arrow-stem_width"
			:id="`${prefix}measurements-arrow-stem_width`"
			:name="`${prefix}measurements[dimensions][stem_width]`"
			unit="cm"
			:label="dimensionLabel('stem_height', 'arrow')"
			:invalid="!isDimensionValid(`${prefix}arrow-stem_width`)"
			:onBlur="() => addSizeToDataLayer('stem_width', +stemWidth, 'arrow')"
			v-model="stemWidth"
		/>

		<dimension-input
			inputRef="arrow-head_length"
			:id="`${prefix}measurements-arrow-head_length`"
			:name="`${prefix}measurements[dimensions][head_length]`"
			unit="cm"
			:label="dimensionLabel('head_width', 'arrow')"
			:invalid="!isDimensionValid(`${prefix}arrow-head_length`)"
			:onBlur="() => addSizeToDataLayer('head_length', +headLength, 'arrow')"
			v-model="headLength"
		/>

		<dimension-input
			inputRef="arrow-head_width"
			:id="`${prefix}measurements-arrow-head_width`"
			:name="`${prefix}measurements[dimensions][head_width]`"
			unit="cm"
			:label="dimensionLabel('head_height', 'arrow')"
			:invalid="!isDimensionValid(`${prefix}arrow-head_width`)"
			:onBlur="() => addSizeToDataLayer('head_width', +headWidth, 'arrow')"
			v-model="headWidth"
		/>
	</shape-input-fields-wrapper>
</template>
